import moment from 'moment';
import { getMedicationsFromDb, getMedsHistoryFromDb, getConditionsFromDb, getIngredientsFromDb, getSupplementsFromDb, getPrescriptionsFromDb} from 'store/localDb';
import { resetAllLoaded } from 'store/storeValtio';

export function sleepPromise(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
// this seems to work for inline javascript if you do the following:
// await waitForSleep(500)
export async function waitForSleep(ms) {
 return await sleepPromise(ms);
}
// not sure this works
export async function sleep(ms) {
  return await waitForSleep(ms);
}

export function generateUniqueId(){
  // Alphanumeric characters
  const chars =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let autoId = '';
  for (let i = 0; i < 20; i++) {
    autoId += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return autoId;
}

// julian date
export function getJD(date) {
  var M = date.month()+1;
  var D = date.date()+1;
  var Y = date.year();
  if (M <= 2) {
    --Y;
    M += 12;
  }

  let A = Math.floor(Y/100);
  let B = Math.floor(A/4);
  let C = 2-A+B;
  let E = Math.floor(365.25 * (Y+4716));
  let F = Math.floor(30.6001 * (M+1));
  let JD = C+D+E+F-1524;
  //console.log(M, D, Y, JD);
  return Math.floor(JD);
}

  export function getNowISO() {
    return new Date().toISOString();
  }
  
  export function formatTime(ts) {
    return moment(ts).format('llll');
  }
  
  export function formatTimeShort(ts) {
    return moment(ts).format('dd, MM/DD h:mm A');
  }

  export function compareISODates(i1, i2) {
    if (i1 === i2) return 0;
    const d1 = moment(i1);
    const d2 = moment(i2);
    if (d1.isBefore(d2)) return -1;
    return 1;
  }
  
  // convert HH:MM AM to minutes since midnight
export function timeToMinutes(time) {
  if (!time) return 0;
  let min = 0;
  let hrs = 0;
  var regexp = /^(\d+):(\d+)\s?([A-Z]+)$/
  let parts = time.match(regexp);
  if (!parts) return min;
  //console.log('parts', parts);
  if (parts.length === 4) {
    hrs = parseInt(parts[1]);
    min = parseInt(parts[2]);
    //console.log('h m', hrs, min);
    if ( hrs === 12 ) hrs = 0;
    if (parts[3] === 'PM' ) min += 720;
    min += hrs * 60;
  }
  //console.log(time, min)
  return min;
}
  
  // convert minutes to HH:MM xM
  export function minutesToTime(minutes) {
    let ampm = ' AM';
    if (minutes >= 720) {
      minutes -= 720;
      ampm = ' PM';
    }
    const hrs = minutes / 60;
    const min = minutes % 60;
    //console.log(minutes, hrs, min);
  
    return twoDigits(hrs) + ':' + twoDigits(min) + ampm;
  }
  
  export function twoDigits(n) {
    return n > 9 ? '' + n : '0' + n;
  }
  
  // get minutes since midnight from moment
  export function minutesSinceMidnight(mmt) {
    if (!mmt) mmt = moment();
    const msm = (mmt.hours() * 60) + mmt.minutes();
    //console.log('msm', mmt, msm )
    return msm;
  }

  export function setMomentToday(hrs, min) {
    const date = new Date();
    date.setSeconds(0);
    date.setMilliseconds(0);
    date.setHours(hrs);
    date.setMinutes(min);
    const mnt = moment(date);
    //console.log('setMomentToday', mnt);
    return mnt;
  }
  
  // convert HH:MMxM to moment
  // adds minutes to current date (as of midnight)
  export function timeToMoment(time) {
    if (!time) return null;
    const minFromMidnight = timeToMinutes(time);
    const hr = Math.floor(minFromMidnight/60);
    const min = minFromMidnight % 60;
    const mnt = setMomentToday(hr, min);
    //console.log('ttm', time, hr, min, mnt, date);
    return mnt;
  }
  
  export function timeToISODate(time) {
    if (isNullOrEmpty(time)) time = "6:00AM";
    let date = timeToMoment(time).toISOString();
    return date;
  }
  
  export function dayOfWeek(weekday) {
    switch (weekday) {
      case 'Sunday':
        return 0;
      case 'Monday':
        return 1;
      case 'Tuesday':
        return 2;
      case 'Wednesday':
        return 3;
      case 'Thursday':
        return 4;
      case 'Friday':
        return 5;
      case 'Saturday':
        return 6;
      default:
        return -1;
    }
  }
  
  export function timeGrid() {
    var d = moment().set('hour', 0).set('minute', 0).set('seconds', 0);
    var tg = [];
    for (var i = 0; i < 96; i++) {
      const time = d.format('hh:mm A');
      const min = timeToMinutes(time);
      //console.log(time, min);
      const t = {
        time: time,
        min: min
      }
      tg.push(t);
      d.add(15, 'minutes');
    }
    return tg;
  }
  
  export function parseForm(form) {
    if (!form || form.nodeName !== 'FORM') {
      return;
    }
    var i,
      j,
      q = [],
      o = {};
    for (i = form.elements.length - 1; i >= 0; i = i - 1) {
      if (form.elements[i].name === '') {
        continue;
      }
      switch (form.elements[i].nodeName) {
        case 'INPUT':
          switch (form.elements[i].type) {
            case 'text':
            case 'number':
            case 'date':
            case 'hidden':
            case 'email':
            case 'password':
            case 'button':
            case 'reset':
            case 'submit':
              o[form.elements[i].name] = form.elements[i].value;
              q.push(form.elements[i].name + ':' + form.elements[i].value);
              break;
            case 'checkbox':
            case 'radio':
              o[form.elements[i].name] = form.elements[i].checked ? true : false;
              q.push(form.elements[i].name + (form.elements[i].checked ? ':true' : ':false'));
              break;
            default:
              break;
          }
          break;
        case 'file':
          break;
        case 'TEXTAREA':
          q.push(
            form.elements[i].name +
              ':' +
              form.elements[i].value
          );
          break;
        case 'SELECT':
          switch (form.elements[i].type) {
            case 'select-one':
              o[form.elements[i].name] = form.elements[i].value;
              q.push(form.elements[i].name + ':' + form.elements[i].value);
              break;
            case 'select-multiple':
              for (j = form.elements[i].options.length - 1; j >= 0; j = j - 1) {
                if (form.elements[i].options[j].selected) {
                  q.push(
                    form.elements[i].name +
                      ':' +
                      form.elements[i].options[j].value
                  );
                }
              }
              break;
            default:
              break;
          }
          break;
        case 'BUTTON':
          switch (form.elements[i].type) {
            case 'reset':
            case 'submit':
            case 'button':
              q.push(
                form.elements[i].name +
                  ':' +
                  form.elements[i].value
              );
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    }
    //data = q.join('&');
    return o;
  }
  
export async function loadDataFromDb(userId) {
  //console.log('loadData', userId);
  getMedicationsFromDb();
  getMedsHistoryFromDb();
  getPrescriptionsFromDb();
  getConditionsFromDb();
  getSupplementsFromDb();
  getIngredientsFromDb();
}

export async function reloadDataFromDb(userId) {
  console.log('reloadData', userId);

  // clear the current store
  resetAllLoaded();
  
  getMedicationsFromDb();
  getMedsHistoryFromDb();
  getPrescriptionsFromDb();
  getConditionsFromDb();
  getSupplementsFromDb();
  getIngredientsFromDb();
}

export function validateEmail(email) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const isValid = emailPattern.test(email);
  return isValid;
}

export function isNullOrEmpty(str) {
  if (str === undefined) return true;
  if (str === null || str.trim() === '') return true;
  return false;
}

export function exportData(data, filename) {
  const link = document.createElement("a");
  const file = new Blob([data], { type: "text/plain;charset=utf-8" });
  const url = URL.createObjectURL(file);
  link.href = url;
  link.download = filename;
  link.click();
};

export function ISOToMMDDYYYY(iso) {
  if (!iso) return '';
  const mnt = moment(iso);
  return mnt.format('MM/DD/YYYY');
}
